import { formatNumber } from 'core/service/lib/number-format'

export const dashedOutOrWithPrecision = (value, precision, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

export const PolicyGioValueRow = ({
  age,
  yearEndPolicy,
  annualBasicPremium,
  cumulativeBasicPremium,
  cashDrop,
  lowSavingCashDrop,
  deathBenefit,
  surrenderCash,
  dividend,
  savingDividend,
  deathBenefitPlusDividend,
  surrenderCashPlusDividend,
}) => {
  return (
    <tr id={`policy-value-row-${age.value}`}>
      <td className="policy-value-age">{age.value}</td>
      <td className="policy-value-year">{yearEndPolicy}</td>
      <td className="policy-value-annual-basic-premium">{annualBasicPremium}</td>
      <td className="policy-value-cumulative-basic-premium">{cumulativeBasicPremium}</td>
      <td className="policy-value-cash-drop">{cashDrop}</td>
      <td className="policy-value-cash-drop">{lowSavingCashDrop}</td>
      <td className="policy-value-cash-drop">{dividend}</td>
      <td className="policy-value-cash-drop">{savingDividend}</td>
      <td className="policy-value-death-benefit">{deathBenefit}</td>
      <td className="policy-value-cumulative-death-benefit">{deathBenefitPlusDividend}</td>
      <td className="policy-value-surrender-cash">{surrenderCash}</td>
      <td className="policy-value-surrender-cash">{surrenderCashPlusDividend}</td>
    </tr>
  )
}
export default PolicyGioValueRow
